import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 bg-surface" data-id="element-178">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-179">
        <div className="text-center mb-16" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-181">
            EMPEZÁ HOY
          </h2>
        </div>

        <div className="max-w-md mx-auto" data-id="element-182">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 border-2 border-primary shadow-xl relative flex flex-col" data-id="element-183">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-primary to-secondary text-white px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1 shadow-md" data-id="element-184">
              <Star className="w-4 h-4 fill-white" data-id="element-185" /> OFERTA DE LANZAMIENTO
            </div>

            <div className="text-3xl mb-4 text-center" data-id="element-186">📘</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-187">
              MEGAPACK OPERATIVO AIRBNB MANAGER
            </h3>
            <p className="text-primary font-bold mb-6 text-center" data-id="element-188">
              6 Tomos + 6 Bonos
            </p>

            <div className="bg-primary/5 p-4 rounded-xl mb-8 text-sm text-gray-600 border border-primary/10 text-center" data-id="element-189">
              Para quien quiere arrancar o escalar su gestión de propiedades en
              dólares.
            </div>

            <div className="mb-8 text-center" data-id="element-190">
              <div className="text-gray-400 line-through text-lg font-medium" data-id="element-191">
                $69.000
              </div>
              <div className="text-5xl font-extrabold text-gray-900" data-id="element-192">
                $19.990{' '}
                <span className="text-lg text-gray-500 font-medium" data-id="element-193">ARS</span>
              </div>
            </div>

            <a href="https://www.iterapro.shop/checkouts/cn/hWNBlFOOMww9wDpt5gWKQ5lS/es-ar?_r=AQABqj-sTAqS3u_oZF2xIAQCkLeqZFjYy96SSuUsFF8v3MM&cart_link_id=0TVX6ial&preview_theme_id=163813163097" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 bg-gradient-to-r from-primary to-secondary hover:shadow-lg hover:shadow-primary/30 text-white font-bold rounded-xl transition-all mt-auto transform hover:scale-[1.02] block text-center" data-id="element-194">
              🔴 QUIERO MI MEGAPACK AHORA
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}